import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import Container from '@material-ui/core/Container';
import { Grid } from '@material-ui/core';
import { toLonLat } from 'ol/proj';
import { connect, useDispatch, useSelector } from 'react-redux';

import Icons from 'consts/icons';
import { authGetRequestWithParams } from 'helpers/apiRequests';
import { uavoDataCardRefreshInterval } from 'consts/config';
import { setDashboardSelectedUavos } from 'store/actions/dashboard/selectedUavos';
import { convertFeetToMeters } from 'utils/main';
import { HEIGHT_UNITS } from 'consts/units';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Tooltip from '@material-ui/core/Tooltip';
import { formStyles } from 'consts/styles/Form';
import AircraftDetails from './AircraftsDetails';
import WeatherDetails from './Weather';

const DetailsCard = props => {
  const { uavo, src, follow, zoomToUavo, heightUnit, isSelectButton } = props;
  const [uavoData, setUavoData] = React.useState(uavo.getProperties());
  const [weather, setWeather] = React.useState({});
  const [weatherLoaded, setWeatherLoaded] = React.useState(null);
  const [followObject, setFollowObject] = React.useState();

  const dispatch = useDispatch();

  const uavoRef = React.useRef();

  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const subtitles = useString().uavoDetails;
  const weatherTitles = useString().weather;

  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  React.useEffect(() => {
    if (followObject) setFollowObject(false);
    getWeather(uavo);
    setUavoData(uavo.getProperties());
    const interval = setInterval(() => {
      if (uavoData.data.id || uavoData.data.uid) {
        setUavoData(uavo.getProperties());
        uavoRef.current = uavo;
      }
    }, uavoDataCardRefreshInterval);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uavo]);

  const manageHeightUnit = altitude => {
    if (!altitude || altitude === 0) return `0${heightUnit}`;
    if (heightUnit === HEIGHT_UNITS.feets) {
      return `${convertFeetToMeters(altitude, true)}${heightUnit}`;
    }
    if (heightUnit === HEIGHT_UNITS.meters) {
      return `${altitude}${heightUnit}`;
    }
  };

  const getWeather = uavoFeature => {
    setWeatherLoaded(false);
    const lonLat = toLonLat(uavoFeature.getGeometry().getCoordinates());
    authGetRequestWithParams('weather', {
      lat: lonLat[1],
      lon: lonLat[0],
    }).then(result => {
      if (result.status === 200) {
        setWeather(result.data);
      }
      setWeatherLoaded(true);
    });
  };

  const showOnMap = selectedUavo => {
    dispatch(setDashboardSelectedUavos([selectedUavo]));
  };

  const handleZoom = () => {
    const id = uavo.getProperties().data.id
      ? uavo.getProperties().data.id
      : uavo.getProperties().data.uid;
    zoomToUavo(id);
  };

  const handleFollow = selectedUavo => {
    dispatch(setDashboardSelectedUavos([selectedUavo]));
    follow();
  };

  const toggleFolloObject = () => {
    const id = uavo.getProperties().data.id
      ? uavo.getProperties().data.id
      : uavo.getProperties().data.uid;
    setFollowObject(followObject !== undefined ? !followObject : true);
    if (!followObject) zoomToUavo(id);
  };

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (followObject === true) handleFollow(uavo);
    }, 500);
    return () => clearTimeout(timer);
  }, [followObject]);

  return (
    <Grid
      container
      className={`${formClasses.Form}__overflow-component ${formClasses.Form}--flex ${formClasses.Form}--flex--direction ${formClasses.Form}--flex--flex-end`}
    >
      <Container>
        <Grid
          container
          spacing={1}
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
        >
          <Grid item xs={3}>
            <img
              className={`${formClasses.Form}--invert`}
              alt="loading problem..."
              src={src}
            ></img>
          </Grid>
          <Grid item xs={7}>
            <div className={`${formClasses.Form}__label`}>
              {`${subtitles.id_}: `}
              <span
                className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
              >
                {uavoData.data.id ? uavoData.data.id : uavoData.data.uid}
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={2}
            align="right"
            className={`${formClasses.Form}--flex ${
              isSelectButton > 1
                ? `${formClasses.Form}--flex--between`
                : `${formClasses.Form}--flex--flex-end`
            }`}
          >
            <Tooltip title={subtitles.zoom_} placement="right">
              <Button
                type="button"
                fullWidth
                onClick={() => handleZoom()}
                className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
              >
                <Icons.Zoom.ZoomInOnMap />
              </Button>
            </Tooltip>
            {isSelectButton > 1 ? (
              <Tooltip title={subtitles.button_} placement="right">
                <Button
                  type="button"
                  fullWidth
                  onClick={() => showOnMap(uavo)}
                  className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                >
                  <Icons.Zoom.ZoomIn />
                </Button>
              </Tooltip>
            ) : null}
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid
          container
          spacing={1}
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--height--dashboard-min-height`}
        >
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.lon_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {uavoData.data.position?.coordinates[0]}
            </span>
          </Grid>
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.lat_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {uavoData.data.position?.coordinates[1]}
            </span>
          </Grid>

          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.speed_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {uavoData.data.speed
                ? `${uavoData.data.speed?.toFixed(2)} ${subtitles.speedUnit_}`
                : '-'}
            </span>
          </Grid>
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.altitude_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {(() => {
                const alt = uavoData.data.altitude_amsl ?? uavoData.data.altitude ?? uavoData.data.baro_altitude;
                if (!alt && alt !== 0) return '-';
                const val = Number(alt).toFixed(2);
                return `${heightUnit === 'ft.' ? convertFeetToMeters(val, true) : val} ${heightUnit}`;
              })()}

              {uavoData.data.type !== 'drone' ? subtitles.altitudeUnit_ : ''}
            </span>
          </Grid>

          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.track_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {uavoData.data.track?.toFixed(2) || '-'}
            </span>
          </Grid>
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.type_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {uavoData.data.type}
            </span>
          </Grid>

          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.sources_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {uavoData.data.sources?.length
                ? uavoData.data.sources.map(source => `${source}, `)
                : uavoData.data.source}
            </span>
          </Grid>
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.ids_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {uavoData.data.ids?.length
                ? uavoData.data.ids.map(id => `${id}, `)
                : uavoData.data.id || '-'}
            </span>
          </Grid>
          {uavoData.data.type !== 'drone' ? (
            <AircraftDetails subtitles={subtitles.aircrafts} data={uavoData} />
          ) : null}
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <WeatherDetails
                weatherTitles={weatherTitles}
                weather={weather}
                weatherLoaded={weatherLoaded}
                subtitles={subtitles}
              />
            </Grid>
            <Grid item xs={2}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.follow_}
              </span>
              <Switch
                color="primary"
                checked={followObject || false}
                onChange={() => toggleFolloObject()}
                name="followObject"
                inputProps={{ 'aria-label': 'followObject' }}
                classes={{
                  checked: `${formClasses.Form}__switch`,
                  track: `${formClasses.Form}__switch__track`,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

const mapStateToProps = state => ({
  heightUnit: state.heightUnit,
});

DetailsCard.propTypes = {
  uavo: PropTypes.object.isRequired,
  src: PropTypes.string.isRequired,
  follow: PropTypes.func.isRequired,
  zoomToUavo: PropTypes.func.isRequired,
  heightUnit: PropTypes.string.isRequired,
  isSelectButton: PropTypes.number,
};

export default connect(mapStateToProps)(DetailsCard);
